var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import { UiButton } from '../UiButton';
import { UiFlex, UiIconMaterial } from '../..';
import './UiButtonCheckbox.css';
export function UiButtonCheckbox(_a) {
    var value = _a.value, onChange = _a.onChange, children = _a.children, rest = __rest(_a, ["value", "onChange", "children"]);
    return (React.createElement(UiButton, __assign({}, rest, { onClick: function () {
            var _a;
            (_a = rest.onClick) === null || _a === void 0 ? void 0 : _a.call(rest);
            onChange(!value);
        }, color: value && 'secondary', className: clsx('UiButtonCheckbox', value && 'checked') }),
        React.createElement(UiFlex, { spacing: 1 },
            React.createElement("div", { className: "icon" }, value ? (React.createElement(UiIconMaterial, null, "check_box")) : (React.createElement(UiIconMaterial, null, "check_box_outline_blank"))),
            React.createElement("div", null, children))));
}
